<template>
  <div class="A06_gsfc aboutchild">
    <div class="aboutchildbox">
      <div class="title">
        <img src="@/common/images/about/A10_xgsm/titleL.png" alt="" />
        <span>联系我们</span>
        <img src="@/common/images/about/A10_xgsm/titleR.png" alt="" />
      </div>
      <div class="imgs">
        <img style="width: 1090px;" src="@/common/images/about/A09_lxwm/pic0@3x.png" alt="联系电话" />
        <img src="@/common/images/about/A09_lxwm/pic1.png" alt="官方邮箱" />
        <img src="@/common/images/about/A09_lxwm/pic2.png" alt="公司地址" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A09_lxwm",
  data() {
    return {
      pages: {
        current: 1,
        total: 100,
        size: 10,
      },
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist: function () {
      // console.log("lawColumn");
    },
    pagefun: function (p) {
      console.log(p);
    },
    toDetail: function () {
      this.$router.push({ path: "/B10_xgsm" });
    },
  },
};
</script>
<style scoped>
.aboutchild {
  width: 100%;
  overflow: hidden;
  opacity: 1;
  background: #fff;
}
.aboutchildbox {
  width: 1102px;
  min-height: 940px;
  opacity: 1;
  margin-left: 267px;
  overflow: hidden;
}
.title {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 26px;
}
.title span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.imgs {
  width: 1102px;
}
.imgs img {
  display: inline-block;
  margin: 0 auto;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A09_lxwm.vue